export function makeFieldsData (studentData, subjectId) {
  const fields = {}
  // var examMark = null
  studentData.forEach(function(student) {
    if (student.length !== 0) {
      const markField = `enroll_mark[${student.enrollment_id}][grade]`
      let subGradeArray = student.subjectGrades
      let subGradeMark = subGradeArray.filter(obj => obj.subject_id === subjectId)
      if (subGradeMark.length !== 0) {
        fields[markField] = subGradeMark[0].grade
      } else {
        fields[markField] = null
      }
    }
  })
  return fields
}
